import { BELGE_TURU_LISTESI } from "../constants/requestUrls";
import {  postRequest } from "../request";

const belgeTuruLists = (BelgeGrubuId) => {
    let filterModel= {};
    filterModel.BelgeGrubuId=BelgeGrubuId;
    let data = JSON.stringify(filterModel);
    return postRequest({url:BELGE_TURU_LISTESI,data});
}

export default belgeTuruLists;